import ErrorBoundary from '../pages/erro-boundary'
import AlunosPage from '../pages/admin/pages/students/list'
import { ListBlogs } from '../pages/admin/pages/blog/listBlog'
import { ShowPEFriends } from '../pages/admin/pages/showPEFriends'
import { BlogAdmin } from '../pages/admin/pages/blog/registerBlog'
import { EditFormStudent } from '../pages/admin/pages/students/edit'
import { AlunoPage } from '../pages/admin/pages/students/student.admin'
import { InstitutionPage } from '../pages/admin/pages/institutions/details'
import { StudentsFormStepSuccess } from '../pages/students/success/index.tsx'
import { OpenDocument } from '@/pages/admin/pages/students/parts/open-document'
import { InterestedPartners } from '../pages/admin/pages/showInterestedPartners'
import { AddInstitutionPage } from '../pages/admin/pages/institutions/add-institution'
import { InstitutionsPage } from '../pages/admin/pages/institutions/institutions.admin'

export const adminRoutes = [
  {
    path: '*',
    element: (
      <ErrorBoundary>
        <AlunosPage />
      </ErrorBoundary>
    ),
  },
  { path: '/institution', element: <InstitutionsPage /> },
  { path: '/institution/:id', element: <InstitutionPage /> },
  { path: '/institution/adicionar', element: <AddInstitutionPage /> },
  { path: '/aluno', element: <AlunosPage /> },
  { path: '/aluno/:id', element: <AlunoPage /> },
  { path: '/aluno/:id/document/:filename', element: <OpenDocument /> },
  { path: '/aluno/edit/:id', element: <EditFormStudent /> },
  { path: '/aluno/edit/:id/success', element: <StudentsFormStepSuccess /> },
  { path: '/show-pe-friends', element: <ShowPEFriends /> },
  { path: '/blogs', element: <ListBlogs /> },
  { path: '/blog/register', element: <BlogAdmin /> },
  { path: '/blog/register/:id', element: <BlogAdmin /> },
  { path: '/interested-partners', element: <InterestedPartners /> },
]
